export type OrderItemTaskModel = {
  address: string,
  cache_key: number,
  completed_date: {
    [key: string]: any,
    date: string,
  },
  data?: any,
  due_date?: string,
  id: number,
  instructions?: string,
  instruction_image?: {
    large: string,
  },
  notes?: string,
  order_item_id?: number,
  order_item_task_type_id: number,
  provider_employee_id?: number,
  provider_id?: number,
  sort_order?: number,
  status_id: number,
}

export type OrderItemTaskRequestOptions = {
  include_task_attachment_image?: boolean,
  include_task_attachments?: boolean,
  include_task_instruction_image?: boolean,
  include_task_order_item?: boolean,
  include_task_type?: boolean,
}

const state = {
  address: '',
  data: {},
  due_date: '',
  id: null,
  instruction_image_file: '',
  instructions: '',
  order_item_id: undefined,
  order_item_task_type_id: undefined,
  provider_employee_id: undefined,
  provider_id: undefined,
  status_id: undefined,
}

export const requiredFields = [
  { key: 'address' },
  { key: 'order_item_task_type_id' },
]

export default state
